import { useTranslation } from "react-i18next";
import Avatar from "components/commons/Avatar";
import secondsToHms from "utility/SecondToHms";


export default function OvertimeRow({
    overtime
}) {

    const [t] = useTranslation(["global", "absenceReport"])
    const startToday = new Date(overtime.startDate * 1000).toLocaleDateString() == new Date().toLocaleDateString()
    const future = new Date(overtime.startDate * 1000) >= new Date()
    const startDateString = startToday ? <b className="text-accent">{t("time.today")}</b> : new Date(overtime.startDate * 1000).toLocaleDateString()
    const createdDateString = new Date(overtime.createdDate).toLocaleDateString() == new Date().toLocaleDateString() ? t("time.today") : new Date(overtime.createdDate).toLocaleDateString()

    return (
        <section >
            <hr />
            <div className={`row ${startToday ? "bg-success bg-opacity-25 p-2 rounded" : null} ${future ? "bg-primary bg-opacity-25 p-2 rounded" : null}`}>

                {
                    overtime.user &&
                    <div className="col-sm">
                        <Avatar displayName={overtime.user.displayName} guid={overtime.user.guid} />
                    </div>
                }


                <div className="col-sm">
                    <b>{secondsToHms(overtime.endDate - overtime.startDate)}</b>
                </div>

                <div className="col-sm">
                    <p>
                        {startDateString}<br />
                        {new Date(overtime.startDate * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {new Date(overtime.endDate * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />

                    </p>
                </div>
                <div className="col-sm">
                    {overtime.note ?
                        <section>
                            <i className="fa-solid fa-circle-info"></i><br />
                            <p className="bg-dark p-2">
                                {overtime.note}
                            </p>
                        </section> : ""}
                </div>
                <div className="col-sm">
                    {createdDateString}<br />
                    {new Date(overtime.createdDate).toLocaleTimeString()}
                </div>
                {
                    overtime.user &&
                    <div className="col-sm">
                        {/* Actions */}
                    </div>
                }
            </div>


        </section>

    )
}